var components
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.__get_style([
    _vm.customStyle,
    {
      overflow: _vm.ripple ? "hidden" : "visible"
    }
  ])

  var m0 = Number(_vm.hoverStartTime)
  var m1 = Number(_vm.hoverStayTime)
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        m0: m0,
        m1: m1
      }
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }